import { useContext, useState } from "react";
import { Box } from "@mui/material";
import DashboardContent from "./DashboardContent";
import AppContext from "../../AppContext";
import bannerSrc from "@arelia-assets/banner1.jpg";
//import AreliaUI from "./arelia-ui";
import theme from "../../theme";
import ImageHeader from "@arelia-components/layout/ImageHeader";

export default function Dashboard() {
  const [navValue, setNavValue] = useState("/profile");
  const { account } = useContext(AppContext);

  return (
    <Box
      bgcolor={theme.palette.background.default}
      flexGrow={1}
      height={1}
      display="flex"
      flexDirection="column"
      gap={"34px"}
      sx={{
        overflowY: "auto",
      }}
    >
      <ImageHeader
        title="Dashboard"
        backgroundUrl={account?.backgroundUrl || bannerSrc}
        navOptions={[]}
        navValue={navValue}
        setNavValue={setNavValue}
        dashboard
      ></ImageHeader>
      <Box p={5} pt={2}>
        {/* <AreliaUI /> */}

        <DashboardContent />
      </Box>
    </Box>
  );
}
